"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBenefitPlanTypeLabel = getBenefitPlanTypeLabel;
exports.getTypesMultiValues = getTypesMultiValues;
exports.draggableTypes = exports.availablePlansColumnName = exports.tierStatusOptions = exports.tierStatusLabels = exports.benetifTiersStatusBadges = exports.tierStatus = exports.benefitPlanCostTypeOptions = exports.benefitPlanCostTypeLabels = exports.benefitPlanCostTypes = exports.benefitStatusLabels = exports.benefitStatus = exports.benefitPlanCategoryOptions = exports.benefitPlanCategoryLabels = exports.benefitPlanCategory = exports.benefitPlanTypeOptions = exports.benefitPlanTypeLabels = exports.benefitPlanType = exports.benefitPlanStatusLabelsEmployee = exports.benetifStatusOptions = exports.benetifStatusLabels = exports.benetifStatusBadges = exports.benefitPlanStatus = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _forms = require("../../helpers/forms");

var _benetifStatusBadges, _benetifStatusLabels, _benefitPlanStatusLab, _benefitPlanTypeLabel, _benefitPlanCategoryL, _benefitStatusLabels, _benefitPlanCostTypeL, _benetifTiersStatusBa, _tierStatusLabels;

var benefitPlanStatus = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  DELETED: 'deleted'
};
exports.benefitPlanStatus = benefitPlanStatus;
var benetifStatusBadges = (_benetifStatusBadges = {}, (0, _defineProperty2["default"])(_benetifStatusBadges, benefitPlanStatus.ACTIVE, 'active'), (0, _defineProperty2["default"])(_benetifStatusBadges, benefitPlanStatus.INACTIVE, 'inactive'), (0, _defineProperty2["default"])(_benetifStatusBadges, benefitPlanStatus.DELETED, 'deleted'), _benetifStatusBadges);
exports.benetifStatusBadges = benetifStatusBadges;
var benetifStatusLabels = (_benetifStatusLabels = {}, (0, _defineProperty2["default"])(_benetifStatusLabels, benefitPlanStatus.ACTIVE, 'Active'), (0, _defineProperty2["default"])(_benetifStatusLabels, benefitPlanStatus.INACTIVE, 'Inactive'), _benetifStatusLabels);
exports.benetifStatusLabels = benetifStatusLabels;
var benetifStatusOptions = (0, _forms.generateSelectOptions)(benetifStatusLabels);
exports.benetifStatusOptions = benetifStatusOptions;
var benefitPlanStatusLabelsEmployee = (_benefitPlanStatusLab = {}, (0, _defineProperty2["default"])(_benefitPlanStatusLab, benefitPlanStatus.ACTIVE, 'Enrolled'), (0, _defineProperty2["default"])(_benefitPlanStatusLab, benefitPlanStatus.INACTIVE, 'Inactive enrolment'), (0, _defineProperty2["default"])(_benefitPlanStatusLab, benefitPlanStatus.PENDING, 'Pending enrolment'), _benefitPlanStatusLab);
exports.benefitPlanStatusLabelsEmployee = benefitPlanStatusLabelsEmployee;
var benefitPlanType = {
  DENTAL: 'dental',
  HEALTH: 'health',
  LIFE: 'life',
  TRAVEL: 'travel',
  VISION: 'vision',
  RETIREMENT: 'retirement'
};
exports.benefitPlanType = benefitPlanType;
var benefitPlanTypeLabels = (_benefitPlanTypeLabel = {}, (0, _defineProperty2["default"])(_benefitPlanTypeLabel, benefitPlanType.DENTAL, 'Dental'), (0, _defineProperty2["default"])(_benefitPlanTypeLabel, benefitPlanType.HEALTH, 'Health'), (0, _defineProperty2["default"])(_benefitPlanTypeLabel, benefitPlanType.LIFE, 'Life'), (0, _defineProperty2["default"])(_benefitPlanTypeLabel, benefitPlanType.TRAVEL, 'Travel'), (0, _defineProperty2["default"])(_benefitPlanTypeLabel, benefitPlanType.VISION, 'Vision'), (0, _defineProperty2["default"])(_benefitPlanTypeLabel, benefitPlanType.RETIREMENT, 'Retirement'), _benefitPlanTypeLabel);
exports.benefitPlanTypeLabels = benefitPlanTypeLabels;
var benefitPlanTypeOptions = (0, _forms.generateSelectOptions)(benefitPlanTypeLabels);
exports.benefitPlanTypeOptions = benefitPlanTypeOptions;

function getBenefitPlanTypeLabel(types) {
  return types.map(function (label) {
    return benefitPlanTypeLabels[label];
  }).join(', ');
}

var benefitPlanCategory = {
  STATUTORY: 'statutory',
  SUPPLEMENTARY: 'supplementary'
};
exports.benefitPlanCategory = benefitPlanCategory;
var benefitPlanCategoryLabels = (_benefitPlanCategoryL = {}, (0, _defineProperty2["default"])(_benefitPlanCategoryL, benefitPlanCategory.STATUTORY, 'Statutory'), (0, _defineProperty2["default"])(_benefitPlanCategoryL, benefitPlanCategory.SUPPLEMENTARY, 'Supplementary'), _benefitPlanCategoryL);
exports.benefitPlanCategoryLabels = benefitPlanCategoryLabels;
var benefitPlanCategoryOptions = (0, _forms.generateSelectOptions)(benefitPlanCategoryLabels);
exports.benefitPlanCategoryOptions = benefitPlanCategoryOptions;
var benefitStatus = {
  ACTIVE: 'active',
  DELETED: 'deleted'
};
exports.benefitStatus = benefitStatus;
var benefitStatusLabels = (_benefitStatusLabels = {}, (0, _defineProperty2["default"])(_benefitStatusLabels, benefitStatus.ACTIVE, 'Active'), (0, _defineProperty2["default"])(_benefitStatusLabels, benefitStatus.DELETED, 'Deleted'), _benefitStatusLabels);
exports.benefitStatusLabels = benefitStatusLabels;

function getTypesMultiValues(types) {
  if (!types) {
    return null;
  }

  return types.map(function (value) {
    return {
      value: value,
      label: benefitPlanTypeLabels[value]
    };
  });
}

var benefitPlanCostTypes = {
  FLAT: 'flat',
  PERCENTAGE: 'percentage'
};
exports.benefitPlanCostTypes = benefitPlanCostTypes;
var benefitPlanCostTypeLabels = (_benefitPlanCostTypeL = {}, (0, _defineProperty2["default"])(_benefitPlanCostTypeL, benefitPlanCostTypes.FLAT, 'Flat cost'), (0, _defineProperty2["default"])(_benefitPlanCostTypeL, benefitPlanCostTypes.PERCENTAGE, 'Percentage of salary'), _benefitPlanCostTypeL);
exports.benefitPlanCostTypeLabels = benefitPlanCostTypeLabels;
var benefitPlanCostTypeOptions = (0, _forms.generateSelectOptions)(benefitPlanCostTypeLabels);
exports.benefitPlanCostTypeOptions = benefitPlanCostTypeOptions;
var tierStatus = {
  DRAFT: 'draft',
  ACTIVE: 'active'
};
exports.tierStatus = tierStatus;
var benetifTiersStatusBadges = (_benetifTiersStatusBa = {}, (0, _defineProperty2["default"])(_benetifTiersStatusBa, tierStatus.ACTIVE, 'active'), (0, _defineProperty2["default"])(_benetifTiersStatusBa, tierStatus.DRAFT, 'inactive'), _benetifTiersStatusBa);
exports.benetifTiersStatusBadges = benetifTiersStatusBadges;
var tierStatusLabels = (_tierStatusLabels = {}, (0, _defineProperty2["default"])(_tierStatusLabels, tierStatus.DRAFT, 'Draft'), (0, _defineProperty2["default"])(_tierStatusLabels, tierStatus.ACTIVE, 'Active'), _tierStatusLabels);
exports.tierStatusLabels = tierStatusLabels;
var tierStatusOptions = (0, _forms.generateSelectOptions)(tierStatusLabels);
exports.tierStatusOptions = tierStatusOptions;
var availablePlansColumnName = 'availablePlans';
exports.availablePlansColumnName = availablePlansColumnName;
var draggableTypes = {
  plan: 'DEFAULT',
  tier: 'tiers'
};
exports.draggableTypes = draggableTypes;